import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-showcase',
  templateUrl: './showcase.component.html',
  styleUrls: ['./showcase.component.scss']
})
export class ShowcaseComponent implements OnInit {

  isLoading: boolean[] = [];
  slider: { title: string, imgUrl: string }[] = [
    {
      title: 'A Legacy of Service',
      imgUrl: '/assets/img/showcase/1.jpg'
    },
    {
      title: 'Vision is everything',
      imgUrl: '/assets/img/showcase/2.jpg'
    },
    {
      title: 'Vision is everything',
      imgUrl: '/assets/img/showcase/3.jpg'
    }

  ];

  setLoader() {
    for (let i = 0; i < this.slider.length; i++) {
      this.isLoading.push(true);
    }
  }

  hideLoader(i: number) {
    this.isLoading[i] = false;
  }

  constructor() { }

  ngOnInit(): void {
    this.setLoader();
    $('.carousel').carousel({
      pause: false
    });
  }

}
